import { render, staticRenderFns } from "./PtrIcon.vue?vue&type=template&id=ef893584&"
import script from "./PtrIcon.vue?vue&type=script&lang=js&"
export * from "./PtrIcon.vue?vue&type=script&lang=js&"
import style0 from "./PtrIcon.vue?vue&type=style&index=0&id=ef893584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports